// Alles wat met tekst en getallen op het scherm te maken heeft.

const monthsShort = [
  "Jan", "Feb", "Mrt", "Apr", "Mei", "Jun",
  "Jul", "Aug", "Sep", "Okt", "Nov", "Dec",
];

// Bedrag als Nederlands getal: 1234.5 wordt "1234,5", hele getallen zonder komma.
export function formatCurrency(value) {
  if (!value && value !== 0) return "0";
  const text = Number.isInteger(value) ? value.toString() : value.toFixed(2);
  return text.replace(".", ",");
}

// "06-2025" wordt "Jun".
export function monthShort(dateStr) {
  if (!dateStr) return "";
  const [month] = dateStr.split("-");
  return monthsShort[parseInt(month, 10) - 1] || "";
}
